// Import the page's CSS. Webpack will know what to do with it.
import '../styles/app.css'

// Import libraries we need.
import { default as Web3 } from 'web3'
import { default as contract } from 'truffle-contract'
import $ from 'jquery'
import 'jquery-ui-bundle'
import 'timepicker'

// Import our contract artifacts and turn them into usable abstractions.
import MyCrowdsaleArtifact from '../../build/contracts/MyCrowdsale.json'
import MyTokenArtifact from '../../build/contracts/MyToken.json'

// MetaCoin is our usable abstraction, which we'll use through the code below.
const MyCrowdsale = contract(MyCrowdsaleArtifact)
const MyToken = contract(MyTokenArtifact)

// The following code is simple to show off interacting with your contracts.
// As your needs grow you will likely need to change its form and structure.
// For application bootstrapping, check out window.addEventListener below.
let accounts
let account
let MyTokenInstance
let CrowdsaleInstance

const App = {
  start: function () {
    // const self = this

    // Bootstrap the MyCrowdsale abstraction for Use.
    MyCrowdsale.setProvider(web3.currentProvider)
    MyToken.setProvider(web3.currentProvider)

    // Get the initial account balance so it can be displayed.
    web3.eth.getAccounts(function (err, accs) {
      if (err != null) {
        alert('There was an error fetching your accounts.')
        return
      }

      if (accs.length === 0) {
        alert("Couldn't get any accounts! Make sure your Ethereum client is configured correctly.")
        return
      }
      accounts = accs
      account = accounts[0]
    })
  },
  // Деплоим токен
  depoloyToken: function () {
    var nameYouToken = $('#nameYouToken').val()
    var symbolYouToken = $('#symbolYouToken').val()
    var decimalsYouToken = 0

    if ($('#decimalsYouToken').val().length !== 0) {
      decimalsYouToken = Number($('#decimalsYouToken').val())
    }

    if ($('#nameYouToken').val().length === 0 || $('#symbolYouToken').val().length === 0) {
      alert('Please fill out this form: Name Token, Symbol Token')
    } else {
      MyToken.new(nameYouToken, symbolYouToken, decimalsYouToken, { from: account }).then(function (instanceMyToken) {
        MyTokenInstance = instanceMyToken
        // $('#adress-token').text(MyTokenInstance.address)
        $('#showToken').remove()
        var showToken = '<div id="showToken"><span class="blue">Adress Token:</span> ' +
          MyTokenInstance.address + '</div>'
        $('#crowdsaleRow').after(showToken)
        $('#showToken').show(600)
        // console.log(MyTokenInstance)
        $('.gray').removeClass('gray')
        $('#createCrowdsale').removeClass('btngray').addClass('btn')
        $('#createCrowdsale').prop('disabled', false)
        $('#startDay').prop('disabled', false)
        $('#startTime').prop('disabled', false)
        $('#finishDate').prop('disabled', false)
        $('#finishTime').prop('disabled', false)
        $('#tokenRate').prop('disabled', false)
        $('#beneficiary').prop('disabled', false)
        $('#softdCap').prop('disabled', false)
        $('#hardCap').prop('disabled', false)
      // MyTokenInstance.name.call().then(nameToken => {
      // $('#name-token').text(nameToken)
      // }).catch(error => {
      // console.log(error)
      // })
      }).catch(error => {
        console.log(error)
      })
    }
  },

  depoloyCrowdsale: function () {
    // var openingTime = web3.eth.getBlock('latest').timestamp + 2
    var currentDate = new Date()
    var currentDateTime = currentDate.getTime() / 1000

    var siteDay = $('#startDay').val()
    var month = Number(siteDay.substring(0, 2)) - 1
    var day = Number(siteDay.substring(3, 5))
    var year = Number(siteDay.substring(6, 10))
    var siteDayConvert = new Date(year, month, day)
    var startHH = 0
    var startMM = 0
    var startTime = $('#startTime').timepicker('getTime')

    if (startTime !== null) {
      startHH = startTime.getHours()
      startMM = startTime.getMinutes()
    }

    var openingTime = siteDayConvert.getTime() / 1000 + startHH * 60 * 60 + startMM * 60

    if ((openingTime + 30) < currentDateTime) {
      openingTime = currentDateTime + 30
    }

    siteDay = $('#finishDate').val()
    month = Number(siteDay.substring(0, 2)) - 1
    day = Number(siteDay.substring(3, 5))
    year = Number(siteDay.substring(6, 10))
    siteDayConvert = new Date(year, month, day)
    var finishHH = 0
    var finishMM = 0
    var finishTime = $('#finishTime').timepicker('getTime')

    if (finishTime !== null) {
      finishHH = finishTime.getHours()
      finishMM = finishTime.getMinutes()
    }
    var closingTime = siteDayConvert.getTime() / 1000 + finishHH + finishMM

    if ((closingTime + 300) < currentDateTime) {
      closingTime = currentDateTime + 300
    }

    var rate = new web3.BigNumber(Number($('#tokenRate').val()))
    // var rate = 1
    // var wallet = '0x42Fc5d8194bAdE46167dbc58124Edb16A1b166c8'
    var wallet = $('#beneficiary').val()
    //  var decimalsYouToken = Number($('#decimalsYouToken').val())
    var cap = new web3.BigNumber(Number($('#hardCap').val()) * Math.pow(10, 18)) // Хардкеп
    var goal = new web3.BigNumber(Number($('#softdCap').val()) * Math.pow(10, 18)) // Софткеп

    if (MyTokenInstance === undefined) {
      alert('Please deploy Token')
    } else {
      if ($('#startDay').val().length === 0 || $('#finishDate').val().length === 0 ||
        $('#tokenRate').val().length === 0 || $('#beneficiary').val().length === 0 ||
        $('#hardCap').val().length === 0 || $('#softdCap').val().length === 0) {
        var str1 = 'Please fill out this form: Start day, Finish date, '
        var str2 = str1 + 'Token rate, Address beneficiary, Soft cap tokens, Hard cap tokens'
        alert(str2)
      } else {
        MyCrowdsale.new(openingTime, closingTime, rate, wallet, MyTokenInstance.address, goal, cap,
          { from: account }).then(function (instanceCrowdsale) {
        // MyCrowdsale.new(openingTime, closingTime, rate, wallet, MyTokenInstance.address,
        // { from: account }).then(function (instanceCrowdsale) {
          CrowdsaleInstance = instanceCrowdsale
          // $('#adress-crowdsale').text(CrowdsaleInstance.address)
          // console.log(CrowdsaleInstance)
          // Добавляем минтера
          MyTokenInstance.addMinter(CrowdsaleInstance.address, { from: account }).then(txResult => {
            $('#showCrowdsale').remove()
            var showToken = '<div id="showCrowdsale"><span class="blue">Adress Crowdsale:</span> ' +
              CrowdsaleInstance.address + '</div>'
            $('#showToken').after(showToken)
            $('#showCrowdsale').show(600)
            // Разблокируем Start CrowdsaleInstance
            $('#amountEth').prop('disabled', false)
            $('#buyTokens').prop('disabled', false)
            $('#checkStatus').prop('disabled', false)
            $('#finalized').prop('disabled', false)
            $('.gray2').removeClass('gray2')
            $('#buyTokens').removeClass('btngray2').addClass('btn')
            $('#checkStatus').removeClass('btngray2').addClass('btn')
            $('#finalized').removeClass('btngray2').addClass('btn')

            // console.log(txResult)
          }).catch(error => {
            console.log(error)
          })
        }).catch(error => {
          console.log(error)
        })
      }
    }
  },

  buyTokens: function () {
    var amountEth = Number($('#amountEth').val())

    CrowdsaleInstance.sendTransaction({ from: account, value: web3.toWei(amountEth, 'ether') }).then(txResult => {
      // console.log(txResult)
    }).catch(error => {
      console.log(error)
    })
  },

  checkStatus: function () {
    var status = '<div id="dataStatus"><span class="blue">Crowdsale data: </span>'

    CrowdsaleInstance.goalReached({ from: account }).then(txResult => {
      status = status + 'Goal reached -  ' + txResult + ', '
      // console.log('goalReached:')
      // console.log(txResult)
    }).catch(error => {
      console.log(error)
    })

    CrowdsaleInstance.capReached({ from: account }).then(txResult => {
      status = status + 'Cap reached -  ' + txResult + ', '
      // console.log('capReached:')
      // console.log(txResult)
    }).catch(error => {
      console.log(error)
    })

    CrowdsaleInstance.finalized({ from: account }).then(txResult => {
      status = status + 'Complete -  ' + txResult + ', '
      // console.log('finalize:')
      // console.log(txResult)
    }).catch(error => {
      console.log(error)
    })

    CrowdsaleInstance.weiRaised({ from: account }).then(txResult => {
      status = status + 'Raised -  ' + web3.fromWei(txResult, 'ether') + ' Eth</div>'
      $('#dataStatus').remove()
      $('#finalized').after(status)
      $('#dataStatus').show(600)
      // console.log('weiRaised:')
      // console.log(txResult)
    }).catch(error => {
      console.log(error)
    })
  },

  finalizedCrowdsale: function () {
    CrowdsaleInstance.finalized({ from: account }).then(finalInst => {
      if (finalInst === true) {
        alert('The project has already been completed!')
      } else {
        CrowdsaleInstance.closingTime({ from: account }).then(timeInst => {
          var currentDate = new Date()
          var currentDateTime = currentDate.getTime() / 1000

          if (timeInst >= currentDateTime) {
            alert('Sorry, Current Time < Closing Time!')
          } else {
            CrowdsaleInstance.finalize({ from: account }).then(txResult => {
              // console.log(txResult)
            }).catch(error => {
              console.log(error)
            })
          }
        })
      }
    }).catch(error => {
      console.log(error)
    })
  }
}

window.App = App

window.addEventListener('load', function () {
  $('#startDay').datepicker()
  $('#finishDate').datepicker()
  $('#startTime').timepicker()
  $('#startTime').on('click', function () {
    $('#startTime').timepicker('setTime', new Date())
  })

  $('#finishTime').timepicker()
  $('#finishTime').on('click', function () {
    $('#finishTime').timepicker('setTime', new Date())
  })

  $('#startDay').prop('disabled', true)
  $('#startTime').prop('disabled', true)
  $('#finishDate').prop('disabled', true)
  $('#finishTime').prop('disabled', true)
  $('#tokenRate').prop('disabled', true)
  $('#beneficiary').prop('disabled', true)
  $('#softdCap').prop('disabled', true)
  $('#hardCap').prop('disabled', true)
  $('#createCrowdsale').prop('disabled', true)

  $('#amountEth').prop('disabled', true)
  $('#buyTokens').prop('disabled', true)
  $('#checkStatus').prop('disabled', true)
  $('#finalized').prop('disabled', true)

  // Checking if Web3 has been injected by the browser (Mist/MetaMask)
  if (typeof web3 !== 'undefined') {
    console.warn(
      'Using web3 detected from external source.' +
      ' If you find that your accounts don\'t appear or you have 0 MetaCoin,' +
      ' ensure you\'ve configured that source properly.' +
      ' If using MetaMask, see the following link.' +
      ' Feel free to delete this warning. :)' +
      ' http://truffleframework.com/tutorials/truffle-and-metamask'
    )
    // Use Mist/MetaMask's provider
    window.web3 = new Web3(web3.currentProvider)
  } else {
    console.warn(
      'No web3 detected. Falling back to http://127.0.0.1:9545.' +
      ' You should remove this fallback when you deploy live, as it\'s inherently insecure.' +
      ' Consider switching to Metamask for development.' +
      ' More info here: http://truffleframework.com/tutorials/truffle-and-metamask'
    )
    // fallback - use your fallback strategy (local node / hosted node + in-dapp id mgmt / fail)
    window.web3 = new Web3(new Web3.providers.HttpProvider('http://127.0.0.1:7545'))
  }

  App.start()
})
